// extracted by mini-css-extract-plugin
export default {"wrapper":"TopicsPage_wrapper__YzMlj","section":"TopicsPage_section__7P3QV","sectionTitle":"TopicsPage_sectionTitle__sC4IB","row":"TopicsPage_row__HbLT4"};